<div class="wrapper" [@fadeInOnEnter] [@fadeOutOnLeave]>
    <h2 class="box-title">
        {{data.title}}
    </h2>
    <p class="details" *ngIf="data.description">
        {{data.description}}
    </p>
    <div *ngIf="(data.customBlocks || []).includes('custom-section-1')">
        <app-main-button
            (onClick)="onBackClick()"
            [buttonWidth]="'100%'"
            [textColor]="'#FFFFFF'"
            [backgroundColor]="'#000000'"
            [buttonText]="'Return to vehicle\'s mobile app'">
        </app-main-button>
    </div>
    <div *ngIf="(data.customBlocks || []).includes('custom-section-2')">
        <app-main-button
            (onClick)="onBackToSelectPlans()"
            [buttonWidth]="'100%'"
            [textColor]="'#FFFFFF'"
            [backgroundColor]="'#000000'"
            [buttonText]="'Return to plans'">
        </app-main-button>
        <app-main-button
            (onClick)="onBackClick()"
            [buttonWidth]="'75%'"
            [textColor]="'#000000'"
            [textDecoration]="'underline'"
            [backgroundColor]="'#FFFFFF'"
            [fontWeight]="'normal'"
            [buttonText]="'Return to vehicle\'s mobile app'">
        </app-main-button>
    </div>
    <div class="custom-section-3" *ngIf="(data.customBlocks || []).includes('custom-section-3')" >
        <p>Please contact Verizon at 1-800-922-0204 to check your eligibility or to get our best Unlimited plans ever.</p>
        <hr class="divider">
        <p class="link-box">
            For more information please visit:
            <a class="link" href="https://www.verizon.com/support/no-longer-supported-plans" target="_blank">https://www.verizon.com/support/no-longer-supported-plans/</a>
        </p>
        <app-main-button
            (onClick)="onBackClick()"
            [buttonWidth]="'189px'"
            [buttonHeight]="'28px'"
            [textColor]="'#000000'"
            [backgroundColor]="'#FFFFFF'"
            [fontWeight]="'700'"
            [fontSize]="'12px'"
            [border]="'2ps solid #000000'"
            [buttonText]="'Return to vehicle\'s mobile app'">
        </app-main-button>
    </div>
</div>
